
import React from 'react';
import { Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { formatPrice } from '@/lib/utils';
import { useCheckoutStore } from '@/stores/checkoutStore';

interface CheckoutSummaryProps {
  course: any;
  amount: number;
}

const CheckoutSummary = ({ course, amount }: CheckoutSummaryProps) => {
  const { discountApplied, originalAmount, discountAmount, discountPercentage } = useCheckoutStore();
  
  return (
    <Card className="overflow-hidden">
      <div className="relative">
        {course.image_url && (
          <img 
            src={course.image_url} 
            alt={course.title} 
            className="w-full h-48 object-cover"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
          <div className="p-4 text-white">
            <h3 className="text-xl font-bold">{course.title}</h3>
          </div>
        </div>
      </div>
      
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center text-sm text-gray-600">
          <Clock className="h-4 w-4 mr-2" />
          <span>{course.duration}</span>
          <span className="mx-2">•</span>
          <span>Koolitaja: {course.instructor || 'Koolitaja'}</span>
        </div>
        
        <div className="border-t pt-4">
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Hind:</span>
            <span className={`font-medium ${discountApplied ? 'line-through text-gray-500' : ''}`}>
              {formatPrice(originalAmount / 100)} €
            </span>
          </div>
          
          {discountApplied && (
            <>
              <div className="flex justify-between items-center mt-2">
                <span className="text-green-600">Allahindlus ({discountPercentage}%):</span>
                <span className="font-medium text-green-600">
                  -{formatPrice(discountAmount / 100)} €
                </span>
              </div>
              
              <div className="flex justify-between items-center mt-2 text-lg">
                <span className="font-semibold">Kokku:</span>
                <span className="font-semibold">
                  {formatPrice(amount / 100)} €
                </span>
              </div>
            </>
          )}
          
          {!discountApplied && (
            <div className="flex justify-between items-center mt-2 text-lg">
              <span className="font-semibold">Kokku:</span>
              <span className="font-semibold">
                {formatPrice(amount / 100)} €
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default CheckoutSummary;
